import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../styles/Specializations.css';

function IndustrialLabourAndEmployment() {

  useEffect(() => {
    document.title = "Industrial Labour and Employment Law - Legal Trails";  // Set Page Title
  }, []);

  return (
    <>
    <Navbar/>
    <div className="law">
      
      <section className="specializations-detail">
        <div  className="container">
          <div className="header-image">
            <img 
              src="./Labour-Law3.jpg" 
              alt="Industrial Labour and Employment"
              loading="lazy"  
              onLoad={(e) => e.target.style.opacity = 1}
              style={{ opacity: 0, transition: "opacity 0.3s ease-in-out" }} 
            />
          </div>
          <div className="content">
            <p>
            At Legal Trails, our team of experienced attorneys specializes in guiding businesses through the complexities of labor laws, ensuring compliance with regulations, and resolving disputes efficiently. We provide comprehensive support for employment documentation and compliance needs, including drafting employment agreements, employee handbooks, consultancy contracts, service bonds, deputation agreements, and grievance redressal mechanisms. Our services also extend to implementing anti-sexual harassment policies, formulating leave policies, certifying standing orders, establishing company rules, and negotiating collective bargaining agreements with trade unions.  

In the real estate sector, we offer a full spectrum of legal services to address the diverse needs of our clients. Our expertise includes drafting and reviewing purchase agreements, sale contracts, and lease agreements, as well as providing assistance with property transactions such as buying, selling, and leasing. We offer legal guidance on land use and zoning regulations, ensuring compliance in property development projects. Additionally, we represent clients in disputes involving real estate transactions, boundary conflicts, and property rights. At Legal Trails, we are committed to helping clients navigate the complexities of labor and real estate laws with confidence and ease.
              </p>
            <div className="button-container">
              <Link to="/contact">
                <button>Contact Us</button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      
    </div>
    <Footer />
    </>
  );
}

export default IndustrialLabourAndEmployment;
